import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Logo } from '@/components';
interface PriceTrendTableProps {
  readonly data: {
    quarter: string;
    maxRange: number;
    averagePrice: number;
    minRange: number;
  }[];
}

export function PriceTrendTable({ data }: PriceTrendTableProps) {
  return (
    <div className="relative overflow-auto">
      <Logo
        color="brand"
        className="pointer-events-none absolute left-1/2 z-0 h-[100px] w-auto -translate-x-1/2 translate-y-1/2 opacity-7"
      />
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Quarter</TableHead>
            <TableHead>Max Price</TableHead>
            <TableHead>Min Price</TableHead>
            <TableHead>Average</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.quarter}</TableCell>
              <TableCell>€ {row.maxRange.toLocaleString('es-ES')}</TableCell>
              <TableCell>€ {row.minRange.toLocaleString('es-ES')}</TableCell>
              <TableCell>€ {row.averagePrice.toLocaleString('es-ES')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
